import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

export function CustomerLogos() {
    new Swiper(".customer-logos", {
        loop: true,
        freeMode: true,
        allowTouchMove: false,
        speed: 5000,
        freeModeMomentum: false,
        autoplay: {
            delay: 1,
            disableOnInteraction: false
        },
        breakpoints: {
            320: {
                slidesPerView: 2.5,
                spaceBetween: 40,
            },
            640: {
                slidesPerView: 2.5,
                spaceBetween: 40,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
            991: {
                slidesPerView: 4,
                spaceBetween: 50,
            },
            1199: {
                slidesPerView: 5,
                spaceBetween: 50,
            },
        }
    });
}
